export default __webpack_public_path__ + "static/media/img-logo-telegram.d82b09f5.svg";